<template>
    <paper class="deposit-details finance-detail">
        <div class="content" v-loading="loading">
            <div class="buttons">
                <el-button @click="goLists">返 回</el-button>
                <Throttle delay="500">
                    <el-button type="primary" @click="payment" :disabled="isPayment" v-has="'07040001'">支付申请</el-button>
                </Throttle>
                <el-button type="primary" :loading="isShowLoading" @click="refund" :disabled="isRefund" v-has="'07040002'">退款申请</el-button>
                <el-button type="primary" class="bigData-btn-look" @click="viewReceipt" :disabled="isPrintIf" v-has="'07040003'">查看收据</el-button>
            </div>
            <div class="line"></div>
            <div class="head-content">
                <div class="head-title">
                    <div class="head-t">
                        <h3 class="head-h3">押金单号：{{this.$route.query.supCashNo}}</h3>
                        <span class="head-r">{{status}}</span>
                    </div>
                    <el-button
                        class="head-btn"
                        @click="isShow = !isShow"
                    >{{this.isShow ? '收起' : '展开'}}</el-button>
                </div>
                <el-collapse-transition>
                    <div v-show="isShow" class="head">
                        <ERow :infoData="infoData" :isContractName="isContractName"></ERow>
                    </div>
                </el-collapse-transition>
            </div>
            <el-tabs v-model="activeName">
                <el-tab-pane label="押金缴纳明细" name="first">
                    <Collect :collectLists="collectLists" :dataLis="dataLis"></Collect>
                </el-tab-pane>
                <el-tab-pane label="押金退还明细" name="second">
                    <Refund :refundList="refundList" :refundLists="refundLists"></Refund>
                </el-tab-pane>
            </el-tabs>
        </div>

        <payment
            v-if="paymentShow"
            ref="paymentRef"
            :payResult="payResult"
            :dataPayLists="dataPayLists"
            :paymentShow.sync="paymentShow"
            @paymentShowClose="paymentShowClose"
            @paymentOk="paymentOk"
            @electronicSign="electronicSign"
            @downloadPDF="paymentDownloadPDF"
            :paymentLoading="paymentLoading"
        ></payment>

        <refund-dialog
            v-if="refundShow"
            :refundShow.sync="refundShow"
            :balance="balance"
            :dataId="dataId"
            :businessId="businessId"
            :dataUrl="dataUrl"
            :dataBalanceObj="dataBalanceObj"
            @refundOk="refundOk"
            @refundCell="refundCell"
            @downloadPDF="downloadPDF"
        ></refund-dialog>
    </paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import ERow from './components/ERow';
import data from './data.js';
import Collect from './components/Collect';
import Refund from './components/Refund';
import payment from './dialog/Payment';
import mixin from './mixins.js';
import Throttle from '@/components/lots/debounce/Debounce';
import refundDialog from './dialog/RefundDialog';
import { del, stAi, accSub } from '../../../components/judge/bmsModular';
import { getDepositDetails, getPreservation, getPaymentOfBeauty, getBidingDocument,
    getBackCode, getRefundLetter, getApplyLetterForPDF, applyLetterElectronicSign, getSaveDrawBack, getRefundDetails, getOrAmtData, getDepositRegressionDetails } from '../../../api/depositDetails';
import { DEPOSITSTATUS, SUPDEPOSITTYPE, CONTRACT_STATUS, BMSDEPOSITAPSTATUS, PRINT_IF, TIMER } from '../../../utils/configuration';
import common from '../../../common/common';
import DepositClass from '../../../common/DepositClass';
import { mapGetters } from 'vuex';
const { initSessionData } = common;
export default {
    mixins: [mixin],
    name: 'depositDetails',
    provide() {
        return {
            getParams: this.getParams,
            loadCellect: this.loadCellect
        };
    },
    computed: {
        ...mapGetters(['visitedViews'])
    },
    components: { Paper, Collect, Refund, payment, refundDialog, ERow, Throttle },
    methods: {
        dataLists() {
            this.companyName = this.details.companyName;
            this.companyCode = this.details.companyCode;
            this.siteCode = this.details.siteCode;
            this.businessId = this.details.jobId;
            this.supCode = this.details.supCode;
            this.supName = this.details.supName;
            this.mdcoContractNo = this.details.mdcoContractNo;
            this.suppliersCode = this.details.suppliersCode;
            this.dataObjPDF.ledgerName = this.details.companyNameText;
            this.dataObjPDF.balanceAmt = this.details.balanceAmt;
            this.dataObjPDF.budgetAmt = this.details.budgetAmt;
            this.dataObjPDF.supplierName = this.details.contractName;
            this.contract = this.details.suppliersCashType;
            this.contractStatus = this.details.statusText;
            this.balance = this.details.balanceAmt;
            this.ledgerId = this.details.ledgerId;
            this.dataPayLists.suppCode = this.details.supCode;
            this.dataPayLists.ledgerId = this.details.ledgerId;
            this.dataBalanceObj.suppCode = this.details.supCode; // 退款申请
            this.dataBalanceObj.ledgerId = this.details.ledgerId; // 退款申请
            this.supCashNo = this.details.supCashNo;
            this.substr6 = this.details.substr6;
            this.substr5 = this.details.substr5;
            this.dataLis.dataJobId = this.details.jobId;
        },
        async load() {
            if (this.$route.query.hasOwnProperty('supCashNo') && this.$route.query.supCashNo !== null) {
                this.loading = true;
                await getDepositDetails({ supCashNo: this.$route.query.supCashNo }).then(res => {
                    if (res && res.code === '0') {
                        this.details = res.data.list[0];
                        const depositData = new DepositClass(this.details);
                        this.dataLists();
                        this.dataPayLists = stAi(this.details, this.dataPayLists);
                        this.infoData = depositData;
                        const { SRM_BMS_SUP_DEPOSIT_STATUS, BID_BUSINESS_TYPE } = window.sessionStorage;
                        this.status = SRM_BMS_SUP_DEPOSIT_STATUS ? JSON.parse(SRM_BMS_SUP_DEPOSIT_STATUS)[this.details.status] : this.details.status;
                        // this.infoData.suppliersCashType = SRM_BMS_SUP_DEPOSIT_TYPE ? JSON.parse(SRM_BMS_SUP_DEPOSIT_TYPE)[this.details.suppliersCashType] : this.details.suppliersCashType;
                        this.infoData.businessProperty = BID_BUSINESS_TYPE ? JSON.parse(BID_BUSINESS_TYPE)[this.details.businessProperty] : this.details.businessProperty;
                        this.dataLis = stAi(this.details, this.dataLis); // 缴纳明细
                        this.refundList = stAi(this.details, this.refundList); // 退还明细
                        this.details.suppliersCashType !== SUPDEPOSITTYPE.OPERATDE_POSIT ? this.isContractName = false : this.isContractName = true;
                        if (this.details.status !== DEPOSITSTATUS.PARTIAL_PAYMENT) {
                            this.isPayment = true;
                            this.isRefund = true;
                        }
                        if (this.details.status === DEPOSITSTATUS.CONFIRM) {
                            this.isPayment = false;
                            this.isRefund = true;
                        }
                        if (this.details.status === DEPOSITSTATUS.FULL_PAYMENT || this.details.status === DEPOSITSTATUS.PARTIAL_REFUND) {
                            this.isRefund = false;
                        }
                        this.details.printIf === PRINT_IF.ONE ? this.isPrintIf = false : this.isPrintIf = true;
                    }
                    this.loading = false;
                }).catch(() => { this.loading = false; });
                this.loadCellect();
                setTimeout(() => { this.getParams(); }, TIMER.THREE_HUNDRED);
            } else {
                this.$message.warning('没有对应的单据编号，不允许查询数据详情');
                this.$router.push({ path: `/bms/deposit` });
                this.visitedViews.forEach(e => {
                    if (e.fullPath === this.$route.fullPath) {
                        this.$store.dispatch('delView', e);
                    }
                }); ;
            }
        },
        paymentDownloadPDF(data) {
            const depoList = data.depositTransfer.every(item => {
                return item.fromSupCashNo && item.fromSupCashNo !== '' && item.fromSupCashNo !== undefined;
            });
            const receiveList = data.receivableTransferDepositModel.every(item => {
                return item.apApplyNo && item.apApplyNo !== '' && item.apApplyNo !== undefined;
            });
            if ((depoList && !receiveList && this.applyAmtNum > 0)) {
                return this.$message.warning('未结单号不能为空');
            }
            if ((!depoList && receiveList) && this.applyAmtDeposit > 0) {
                return this.$message.warning('押金单号不能为空');
            }
            let list1 = [];// 押金调账
            if (data && data.depositTransfer && data.depositTransfer.length) {
                list1 = data.depositTransfer.map(item => ({
                    settlementNo: item.fromSupCashNo.supCashNo || '',
                    applyAmt: item.applyAmt
                }));
            }
            let list2 = [];// 应收转押金
            if (data && data.receivableTransferDepositModel && data.receivableTransferDepositModel.length) {
                list2 = data.receivableTransferDepositModel.map(item => ({
                    settlementNo: item.apApplyNo.apApplyNo || '',
                    applyAmt: item.applyAmt
                }));
            }
            const dataList = list1.concat(list2);
            const params = {
                ledgerName: this.dataObjPDF.ledgerName, // 会计主体名称
                mdcoContractNo: this.mdcoContractNo, // 供应商合同编号
                supCashNo: this.supCashNo, // 押金单号
                budgetAmt: this.dataObjPDF.budgetAmt, // 预算金额
                supName: this.supName, // 供应商名称
                dataList: dataList
            };
            getApplyLetterForPDF(params).then(res => {
                if (res && res.code === '0') {
                    this.dataId = res.data.id;
                    this.dataUrl = res.data.downUrl;
                    this.fileName = res.data.localFileName;
                    window.open(this.dataUrl);
                    this.$message.success('下载成功');
                }
            }).catch(() => {});
        },
        downloadPDF(data) {
            const money = accSub(Number(this.dataObjPDF.balanceAmt), Number(data.data.refundAmount));
            const params = {
                ledgerName: this.dataObjPDF.ledgerName, // 会计主体名称
                theReturnAmt: data.data.refundAmount, // 金额为供应商申请的金额(退款申请金额)
                balanceAmt: this.dataObjPDF.balanceAmt, // 押金余额
                amtBalan: money, // 退款申请余额（押金余额-退款申请金额）
                supplierName: this.dataObjPDF.supplierName, // 合同名称
                mdcoContractNo: this.mdcoContractNo, // 合同编号
                receiptNumber: this.substr5, // 收据编号
                bankName: data.data.bankAccountName, // 开户名称
                uBankNo: data.data.account.ubankno, // 开户行号
                bankAccount: data.data.account.bankAccount, // 银行账号
                bankAccountName: data.data.bankName // 开户银行
            };
            getRefundLetter(params).then(res => {
                if (res && res.code === '0') {
                    this.dataId = res.data.id;
                    this.dataUrl = res.data.downUrl;
                    window.open(this.dataUrl);
                    this.$message.success('下载成功');
                }
            }).catch(() => {});
        },
        async loadCellect() {
            const params = { supCashNo: this.$route.query.supCashNo, companyCode: this.companyCode, siteCode: this.siteCode, supCode: this.supCode, failTime: '' };
            await getDepositRegressionDetails(params).then(res => {
                if (res && res.code === '0') {
                    const { SYS_BMS_DEPOSIT_PAY_TYPE, SYS_BMS_DEPOSIT_AP_STATUS, SRM_YES_NO, SYS_BMS_ESIGNATURE_STATUS } = window.sessionStorage;
                    this.collectLists = res.data.map(item => {
                        item.payTypeText = SYS_BMS_DEPOSIT_PAY_TYPE ? JSON.parse(SYS_BMS_DEPOSIT_PAY_TYPE)[item.payType] : item.payType;
                        item.approveStatusType = SYS_BMS_DEPOSIT_AP_STATUS ? JSON.parse(SYS_BMS_DEPOSIT_AP_STATUS)[item.approveStatus] : item.approveStatus;
                        item.isElectronicSignStr = SRM_YES_NO ? JSON.parse(SRM_YES_NO)[item.isElectronicSign] : item.isElectronicSign;
                        item.eSignatureStr = SYS_BMS_ESIGNATURE_STATUS ? JSON.parse(SYS_BMS_ESIGNATURE_STATUS)[item.esignature] : item.esignature;
                        return item;
                    });
                }
            }).catch(() => {});
        },
        electronicSign(formName) {
            if (!this.dataId) {
                return this.$message.warning('请点击《押金调整函件》下载查阅后再签订；');
            }
            const formLists = formName.data;
            formLists['supCashNo'] = formName.supCashNo;
            formLists['supCode'] = formName.supCode;
            formLists['fileName'] = this.fileName;
            formLists['fileId'] = formName.fileId;
            formLists['businessId'] = this.businessId;
            formLists['dataId'] = this.dataId;
            formLists['dataUrl'] = this.dataUrl;
            formLists.applicationForPaymentModel = [];
            const depoList = formLists.depositTransfer.every(item => {
                return item.fromSupCashNo && item.fromSupCashNo !== '' && item.fromSupCashNo !== undefined;
            });
            const receiveList = formLists.receivableTransferDepositModel.every(item => {
                return item.apApplyNo && item.apApplyNo !== '' && item.apApplyNo !== undefined;
            });
            if ((depoList && !receiveList)) {
                if (this.applyAmtNum > 0) {
                    return this.$message.warning('未结单号不能为空');
                } else {
                    formLists.receivableTransferDepositModel = [];
                }
            }
            if ((!depoList && receiveList)) {
                if (this.applyAmtDeposit > 0) {
                    return this.$message.warning('押金单号不能为空');
                } else {
                    formLists.depositTransfer = [];
                }
            }
            formLists.receivableTransferDepositModel = formLists.receivableTransferDepositModel.map(item => {
                this.applyAmtNum = item.applyAmt;
                item.apApplyNo = item.apApplyNo.apApplyNo;
                delete item.apRealAmt;
                delete item.apAmt;
                return item;
            });
            formLists.depositTransfer = formLists.depositTransfer.map(item => {
                this.applyAmtDeposit = item.applyAmt;
                item.fromSupCashNo = item.fromSupCashNo.supCashNo;
                delete item.balanceAmt;
                delete item.budgetAmt;
                return item;
            });
            this.formLists = del(formLists, ['payType', 'depositOptions', 'depositReceivableOptions']);
            applyLetterElectronicSign(formLists).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('保存成功');
                    this.load();
                }
            }).catch(() => {});
            this.dataId = '';
            this.dataUrl = '';
            this.paymentLoading = false;
            this.paymentShow = false;
        },
        paymentOk(formName) {
            this.paymentLoading = true;
            if (formName.state) {
                this.supCashNo = formName.supCashNo || '';
                this.supCode = formName.supCode || '';
                this.fileName = formName.fileName || '';
                this.fileId = formName.fileId || '';
                const formLists = formName.data;
                formLists['supCashNo'] = this.supCashNo;
                formLists['supCode'] = this.supCode;
                formLists['fileName'] = this.fileName;
                formLists['fileId'] = this.fileId;
                formLists['businessId'] = this.businessId;
                const formNameLists = formLists.applicationForPaymentModel[0];
                this.applyAmt = formNameLists.applyAmt;

                const depoList = formLists.depositTransfer.every(item => {
                    return item.fromSupCashNo && item.fromSupCashNo !== '' && item.fromSupCashNo !== undefined;
                });
                const receiveList = formLists.receivableTransferDepositModel.every(item => {
                    return item.apApplyNo && item.apApplyNo !== '' && item.apApplyNo !== undefined;
                });
                if (formNameLists.payType && formName.checkIsCashPay) {
                    formLists.depositTransfer = [];
                    formLists.receivableTransferDepositModel = [];
                } else {
                    formLists.applicationForPaymentModel = [];
                }
                formLists.receivableTransferDepositModel = formLists.receivableTransferDepositModel.map(item => {
                    this.applyAmtNum = item.applyAmt;
                    item.apApplyNo = item.apApplyNo.apApplyNo;
                    item.isElectronicSign = '0';
                    delete item.apRealAmt;
                    delete item.apAmt;
                    return item;
                });
                formLists.depositTransfer = formLists.depositTransfer.map(item => {
                    this.applyAmtDeposit = item.applyAmt;
                    item.fromSupCashNo = item.fromSupCashNo.supCashNo;
                    item.isElectronicSign = '0';
                    delete item.balanceAmt;
                    delete item.budgetAmt;
                    return item;
                });
                this.formLists = del(formLists, ['payType', 'depositOptions', 'depositReceivableOptions']);
                this.formNameLists = del(formNameLists, ['editing', 'imgName', 'updateUserName', 'imgUrl', 'uploadTime']);
                if (this.applyAmt > 0 && formNameLists.payType === '2') {
                    // 现汇付款-美的付 & 缴纳金额>0
                    getPreservation(formLists, this.supCashNo).then(res => {
                        if (res && res.code === '0') {
                            if (res.data.success === false) {
                                return this.$message.error(res.data.detail);
                            }
                            this.applyNoObj = res.data.data.applyNo;
                            this.$message.success('保存成功');
                            this.paymentLoading = false;
                        }
                        this.getData();
                    }).catch(() => { this.paymentLoading = false; });
                } else if ((depoList || receiveList) === true) {
                    if ((depoList && !receiveList) && this.applyAmtNum > 0) {
                        this.paymentLoading = false;
                        this.paymentShow = false;
                        return this.$message.warning('未结单号不能为空');
                    }
                    if ((!depoList && receiveList) && this.applyAmtDeposit > 0) {
                        this.paymentLoading = false;
                        this.paymentShow = false;
                        return this.$message.warning('押金单号不能为空');
                    }
                    getPreservation(formLists, this.supCashNo).then(res => {
                        if (res && res.code === '0') {
                            if (res.data.success === false) {
                                return this.$message.error(res.data.detail);
                            }
                            this.$nextTick(() => { this.load(); });
                            this.paymentLoading = false;
                            this.paymentShow = false;
                            this.$message.success('保存成功');
                        } else {
                            this.paymentLoading = false;
                            this.paymentShow = false;
                        }
                    });
                } else {
                    if (formNameLists.payType === '2') {
                        // eslint-disable-next-line max-depth
                        if ((!receiveList && !depoList) && (this.applyAmtDeposit > 0 && this.applyAmtNum > 0)) {
                            this.paymentLoading = false;
                            this.paymentShow = false;
                            this.$message.closeAll();
                            return this.$message.warning('押金单号或者未结单号不可为空');
                        } else if (!depoList && this.applyAmtDeposit > 0) {
                            this.paymentLoading = false;
                            this.paymentShow = false;
                            return this.$message.warning('押金单号不能为空');
                        } else if (!receiveList && this.applyAmtNum > 0) {
                            this.paymentLoading = false;
                            this.paymentShow = false;
                            return this.$message.warning('未结单号不能为空');
                        }
                    }
                    if (formNameLists.payType === '' && (!receiveList || !depoList)) {
                        this.paymentLoading = false;
                        this.paymentShow = false;
                        this.$message.closeAll();
                        return this.$message.warning('押金单号或者未结单号不可为空');
                    } else if (formLists.fileName === '' && formNameLists.payType === '1') {
                        this.formNameLists['editing'] = 'arrive';
                        this.paymentLoading = false;
                        return this.$message.warning('请选择一张图片上传');
                    } else {
                        getPreservation(formLists, this.supCashNo).then(res => {
                            if (res && res.code === '0') {
                                if (res.data.success === false) {
                                    return this.$message.error(res.data.detail);
                                }
                                this.applyNoObj = res.data.data.applyNo;
                                this.paymentShow = false;
                                this.$nextTick(() => { this.load(); });
                                this.$message.success('保存成功');
                                this.paymentLoading = false;
                            }
                        }).catch(() => { this.paymentLoading = false; });
                    }
                }
            } else {
                this.paymentLoading = false;
                return false;
            }
        },
        // 美的付
        loadList () {
            const params = { payAmount: this.applyAmt,
                applyNo: this.applyNoObj,
                supCashNo: this.$route.query.supCashNo,
                accountEntity: this.ledgerId,
                companyName: this.companyName,
                supName: this.supName };
            getPaymentOfBeauty(params).then(res => {
                // this.payResult = res;
                // this.$refs.paymentRef.handleSubmit(this.payResult);
                const paramsData = JSON.parse(res.data);
                if (res && res.code === '0') {
                    this.payResult = paramsData;
                    this.$refs.paymentRef.handleSubmit(this.payResult);
                }
            }).catch(() => {});
        },
        getData() {
            const params = { accountEntity: this.ledgerId };
            getBidingDocument(params).then(res => {
                if (res && res.code === '0') {
                    for (let index = 0; index < res.data.list.length; index++) {
                        const dataAccList = res.data.list[index];
                        this.accountCode = dataAccList.accountCode;
                    }
                    this.loadList(() => {
                        this.paymentShow = false;
                    });
                }
            }).catch(() => {});
        },
        // 当客户无法知道自己是否支付成功(可以忽略)
        getCode() {
            const params = { applyNo: this.applyNoObj, accountCode: this.accountCode };
            getBackCode(params).then(res => {}).catch(() => {});
        },
        refundOk(formName) {
            const formData = new FormData();
            formName.file.forEach((item, index) => {
                formData.append(`files[${index}]`, new File([item.file], item.file.name, {
                    type: item.file.type
                }));
            });
            formData.append('businessId', formName.businessId);
            formData.append('supCashNo', formName.supCashNo);
            formData.append('accountName', formName.accountName);
            formData.append('applyAmt', formName.applyAmt);
            formData.append('applyType', '2');
            formData.append('dataId', this.dataId);
            formData.append('dataUrl', this.dataUrl);
            getSaveDrawBack(formData).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('保存成功');
                    this.load();
                }
            }).catch(() => {});
            this.refundShow = false;
        },
        async getParams() {
            this.isShowLoading = true;
            const params = { supCashNo: this.$route.query.supCashNo, suppliersCode: this.suppliersCode };
            await getRefundDetails(params).then(res => {
                if (res && res.code === '0') {
                    const { SYS_BMS_DEPOSIT_AP_STATUS, SRM_YES_NO } = window.sessionStorage;
                    this.refundLists = res.data.map(item => {
                        item.approveStatusType = SYS_BMS_DEPOSIT_AP_STATUS ? JSON.parse(SYS_BMS_DEPOSIT_AP_STATUS)[item.approveStatus] : item.approveStatus;
                        item.isEsignature = SRM_YES_NO ? JSON.parse(SRM_YES_NO)[item.esignature] : item.esignature;
                        return item;
                    });
                }
                this.isShowLoading = false;
            }).catch(() => { this.isShowLoading = false; });
        },
        goLists() { this.$router.push({ path: `/bms/deposit` }); },
        paymentShowClose() { this.paymentShow = false; },
        payment() {
            const params = { supCashNo: this.$route.query.supCashNo };
            getOrAmtData(params).then(res => {
                const getOrAmtObj = JSON.parse(res.data);
                if (res.code === '0' && res) {
                    if (getOrAmtObj.data.success) {
                        this.paymentShow = true;
                        this.$nextTick(() => {
                            // this.$refs.paymentRef.isDisable = true;
                        });
                    } else {
                        return this.$message.warning(getOrAmtObj.data.detail);
                    }
                }
            }).catch(() => {});
        },
        refund() {
            const isExistence = this.refundLists.filter(item => {
                return item.approveStatus < +BMSDEPOSITAPSTATUS.AUDIT_PASS;
            });
            isExistence.forEach(item => {
                this.zfNumber = item.applyNo ? item.applyNo : '';
            });
            // 押金类型为押金，且对应合同状态为(中止、终止、废弃)，或者余额>押金金额的可以点击退款申请，否则提示错误 =====》 合同失效||余额>押金金额
            const types = (this.contractStatus === CONTRACT_STATUS.SUSPENSION || this.contractStatus === CONTRACT_STATUS.TERMINATION || this.contractStatus === CONTRACT_STATUS.DISCARD);
            const moneys = this.infoData.balanceAmt > this.infoData.budgetAmt;
            if (types || moneys) {
                if (isExistence.length > 0 && this.zfNumber !== '') {
                    return this.$message.warning(`${this.zfNumber} 单号退款申请未完结，请通知相关人员处理完毕后再申请`);
                }
                this.refundShow = true;
            } else {
                return this.$message.warning('合同未失效或余额小于押金金额，不能退款');
            }
        },
        refundCell() { this.refundShow = false; },
        viewReceipt() {
            if (this.substr6 && this.substr6 !== '') {
                this.substr6.split(',').forEach((item, index) => {
                    setTimeout(() => { // 修改了setTimeout传参方式
                        // window.open(item);
                        this.downloadFile(item);
                    }, 1000 * index);
                });
            } else {
                return this.$message.warning('查询暂无相关收据');
            }
        },
        downloadFile(url, name) {
            const a = document.createElement('a');
            a.download = name || new Date().getTime();
            a.href = url;
            a.click();
            a.remove();
        }
    },
    mounted() {
        initSessionData(['BID_BUSINESS_TYPE', 'SYS_BMS_DEPOSIT_PAY_TYPE', 'SYS_BMS_DEPOSIT_AP_STATUS', 'SRM_BMS_SUP_DEPOSIT_TYPE', 'SRM_BMS_SUP_DEPOSIT_STATUS', 'SRM_YES_NO',
            'SYS_BMS_ESIGNATURE_STATUS']);
        this.load();
    },
    created() { this.infoData = data.infoData; }
};
</script>

<style lang="less">
@import '../../../styles/common.less';
.deposit-details {
    .head {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
